import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { UpdateCategoryRequestBody } from "./updateCategory.types";

export const requestUpdateCategory = async (
  body: UpdateCategoryRequestBody
): Promise<Category> => {
  return await instance.put(ApiRoutesCategories.MainCategory, body);
};
